module.exports = __webpack_public_path__ + "img/intelligenceOperations.b2d05a8a.svg";